import React from 'react'
import { Sidebar, Segment, Menu, Icon } from 'semantic-ui-react'
import { BrowserRouter , Switch, Route } from 'react-router-dom'
import HealthFundsListContainer from 'components/admin/health_funds/HealthFundsListContainer';
import HealthFundsMenuContainer from 'components/admin/health_funds/HealthFundsMenuContainer';
import HealthFundForm from 'components/admin/health_funds/HealthFundForm';

export default class HealthFunds extends React.Component {
  render () {
    return (
      <div>
        <Switch>
          <Route path={Routes.admin_health_fund_path({id: ":id", _options: true})} render={ props => (
            <Sidebar.Pushable as={Segment} className= "min-height-90">
              <HealthFundsMenuContainer/>
              <Sidebar.Pusher className="left-sidebar-margin">
                <HealthFundForm entityId={props.match.params.id}/>
              </Sidebar.Pusher>
            </Sidebar.Pushable>
           )} />

          <Route path={Routes.admin_health_funds_path()} component={HealthFundsListContainer}/>
        </Switch>
      </div>
    )
  }
}

